import { openDB, type IDBPDatabase, type DBSchema } from 'idb';
import type { Memo } from '@memori-web/shared';

interface MemoriDB extends DBSchema {
  memos: {
    key: string;             // memo id (ULID)
    value: Memo & { dirty: boolean };
    indexes: { 'by-updated': string; 'by-dirty': string };
  };
  meta: {
    key: string;             // 'lastPulledAt' | other singletons
    value: string;
  };
}

const DB_NAME = 'memori-web';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase<MemoriDB>> | null = null;

export function getDB(): Promise<IDBPDatabase<MemoriDB>> {
  if (!dbPromise) {
    dbPromise = openDB<MemoriDB>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        const memos = db.createObjectStore('memos', { keyPath: 'id' });
        memos.createIndex('by-updated', 'updatedAt');
        memos.createIndex('by-dirty', 'dirty');
        db.createObjectStore('meta');
      },
    });
  }
  return dbPromise;
}

// Test-only: reset the singleton so each test gets a fresh fake-indexeddb.
export function _resetDBForTests(): void {
  dbPromise = null;
}
